<template>
  <div>
    <div class="information_title">真实图片</div>
    <div class="picture_title">
      <div class="picture_title_top">
        请不要上传修改痕迹明显、拉伸变形、有水印、有联系方式或品牌宣传等内容的照片。
      </div>
      <div class="picture_title_bottom">
        请认真查看照片范例和要求说明，避免因为审核不通过而耽误上线时间。
      </div>
        <div class="picture_title_bottom">
            总共上传图片至少6张，房屋图片数量最多50张
        </div>
    </div>
    <!-- 封面 -->
    <div class="picture_box">
      <div class="picture_box_top">
        封面：<span
          >请上传
          <div class="text">1</div>
          张横图，建议上传
          <div class="text">客厅或卧室</div>
          的横图。</span
        >
        <!-- （{{ this.from.params.vCoverPic.length }}/1） -->
      </div>
      <div class="picture_box_bottom">
        <div class="picture_upload">
          <!-- <div class="picture_box_title">可添加照片描述</div> -->
          <!-- 上传图片

          -->
          <el-upload
            ref="my-upload"
            :limit="1"
            :headers="headers"
            name="avatarfile"
            :action="GLOBAL"
            list-type="picture-card"
            :on-success="vCoverPicSuccessFour"
            :on-preview="vCoverPicCardPreview"
            :on-remove="vCoverPicRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vCoverPicSuccess"
          >
            <i class="el-icon-plus"></i>
            <!-- <i class="el-icon-plus">添加照片</i> -->
          </el-upload>
          <el-dialog :visible.sync="vCoverPicLook_img">
            <div class="img_title">浏览图片</div>
            <img width="100%" :src="vCoverPicLook" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- 卧室 -->
    <div class="picture_box" v-if="roomNumber">
      <div class="picture_box_top">
        卧室：

              <span >
                  请至少上传
                  <div class="text">
                    <span style="color: #f6b439;" v-if="hourseInfo.houseInfoSon.iRenderType==1">
                        {{ roomNumber * 1 > 10 ? "10" : roomNumber * 1 }}
                    </span>
                      <span v-else style="color: #f6b439;">1</span>
                  </div>
                  张卧室照片。请确保
                  <div class="text">床单、枕头展示齐全。</div>
              </span>

          （{{ from.params.vBedroom.length }}/20）
      </div>
      <div class="picture_box_bottom">
        <div class="picture_upload">
          <!-- <div class="picture_box_title">可添加照片描述</div> -->
          <!-- 上传图片
          -->
            <ul class="el-upload-list el-upload-list--picture-card">
                <draggable v-model="from.params.vBedroom" @start="onStart" @end="onEnd">
                    <li v-for="(item) in from.params.vBedroom" :key="item" class="el-upload-list__item is-success animated">
                        <img :src="item" alt="" class="el-upload-list__item-thumbnail ">
                        <i class="el-icon-close"></i>
                        <span class="el-upload-list__item-actions">
                    <!-- 预览 -->
                    <span class="el-upload-list__item-preview" @click="vBedroomCardPreview(item)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                            <!-- 删除 -->
                    <span class="el-upload-list__item-delete" @click="vBedroomRemove(item)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                    </li>
                </draggable>
            </ul>
          <el-upload
            multiple
            ref="my-upload"
            :limit="20"
            :headers="headers"
            name="avatarfile"
            :action="GLOBAL"
            list-type="picture-card"
            :show-file-list="false"
            :on-success="vBedroomSuccessFour"
            :on-preview="vBedroomCardPreview"
            :on-remove="vBedroomRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vBedroomSuccess"
          >
            <i class="el-icon-upload"></i>
            <!-- <i class="el-icon-plus">添加照片</i> -->
          </el-upload>
          <el-dialog :visible.sync="vBedroomLook_img">
            <div class="img_title">浏览图片</div>

                <img width="100%" :src="vBedroomLook" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- 客厅 -->
    <div class="picture_box" v-if="this.hallNumber">
      <div class="picture_box_top">
        客厅：<span>
          请至少上传
          <div class="text">

               <span style="color: #f6b439;" v-if="hourseInfo.houseInfoSon.iRenderType==1">
                       {{ hallNumber * 1 > 6 ? "6" : hallNumber * 1 }}
               </span>
              <span v-else style="color: #f6b439;">1</span>
          </div>
          张客厅照片。站在厅角拍摄，视野会更广。 </span
        >（{{ this.from.params.vSaloonPic.length }}/20）
      </div>
      <div class="picture_box_bottom">
        <div class="picture_upload">
          <!-- <div class="picture_box_title">可添加照片描述</div> -->
          <!-- 上传图片

          -->
            <ul class="el-upload-list el-upload-list--picture-card">
                <draggable v-model="from.params.vSaloonPic">
                    <li v-for="(item) in from.params.vSaloonPic" :key="item" class="el-upload-list__item is-success animated">
                        <img :src="item" alt="" class="el-upload-list__item-thumbnail ">
                        <i class="el-icon-close"></i>
                        <span class="el-upload-list__item-actions">
                    <!-- 预览 -->
                    <span class="el-upload-list__item-preview" @click="vSaloonPicCardPreview(item)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                            <!-- 删除 -->
                    <span class="el-upload-list__item-delete" @click="vSaloonPicRemove(item)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                    </li>
                </draggable>
            </ul>
          <el-upload
            multiple
            ref="my-upload"
            :limit="20"
            :headers="headers"
            name="avatarfile"
            :show-file-list="false"
            :action="GLOBAL"
            list-type="picture-card"
            :on-success="vSaloonPicSuccessFour"
            :on-preview="vSaloonPicCardPreview"
            :on-remove="vSaloonPicRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vSaloonPicSuccess"
          >
            <i class="el-icon-upload"></i>
            <!-- <i class="el-icon-plus">添加照片</i> -->
          </el-upload>
          <el-dialog :visible.sync="vSaloonPicLook_img">
            <div class="img_title">浏览图片</div>
            <img width="100%" :src="vSaloonPicLook" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- 卫生间 -->
    <div class="picture_box" v-if="bathroomNumber">
      <div class="picture_box_top">
        卫生间：<span>
          请至少上传
          <div class="text">

              <span style="color: #f6b439;" v-if="hourseInfo.houseInfoSon.iRenderType==1">
                      {{ bathroomNumber * 1 > 6 ? "6" : bathroomNumber * 1 }}
               </span>
              <span v-else style="color: #f6b439;">1</span>
          </div>
          张卫生间照片。请确保
          <div class="text">马桶卫浴、地面细节完整。</div> </span
        >（{{ this.from.params.vToiletPic.length }}/20）
      </div>
      <div class="picture_box_bottom">
        <div class="picture_upload">
          <!-- <div class="picture_box_title">可添加照片描述</div> -->
          <!-- 上传图片 -->
            <ul class="el-upload-list el-upload-list--picture-card">
                <draggable v-model="from.params.vToiletPic">
                    <li v-for="(item) in from.params.vToiletPic" :key="item" class="el-upload-list__item is-success animated">
                        <img :src="item" alt="" class="el-upload-list__item-thumbnail ">
                        <i class="el-icon-close"></i>
                        <span class="el-upload-list__item-actions">
                    <!-- 预览 -->
                    <span class="el-upload-list__item-preview" @click="vToiletPicCardPreview(item)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                            <!-- 删除 -->
                    <span class="el-upload-list__item-delete" @click="vToiletPicRemove(item)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                    </li>
                </draggable>
            </ul>
          <el-upload
            multiple
            ref="my-upload"
            :limit="20"
            :headers="headers"
            name="avatarfile"
            :action="GLOBAL"
            :show-file-list="false"
            list-type="picture-card"
            :on-success="vToiletPicSuccessFour"
            :on-preview="vToiletPicCardPreview"
            :on-remove="vToiletPicRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vToiletPicSuccess"
          >
            <i class="el-icon-upload"></i>
            <!-- <i class="el-icon-plus">添加照片</i> -->
          </el-upload>
          <el-dialog :visible.sync="vToiletPicLook_img">
            <div class="img_title">浏览图片</div>
            <img width="100%" :src="vToiletPicLook" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- 厨房 -->
    <div class="picture_box" v-if="kitchenNumber">
      <div class="picture_box_top">
        厨房：<span>
          请至少上传
          <div class="text">

              <span style="color: #f6b439;" v-if="hourseInfo.houseInfoSon.iRenderType==1">
                       {{ kitchenNumber * 1 > 4 ? "4" : kitchenNumber * 1 }}
               </span>
              <span v-else style="color: #f6b439;">1</span>
          </div>
          张厨房照片
          <div class="text">请确保灶具、台面完整。</div> </span
        >（{{ this.from.params.vKitchenPic.length }}/20）
      </div>
      <div class="picture_box_bottom">
        <div class="picture_upload">
          <!-- <div class="picture_box_title">可添加照片描述</div> -->
          <!-- 上传图片 -->
            <ul class="el-upload-list el-upload-list--picture-card">
                <draggable v-model="from.params.vKitchenPic">
                    <li v-for="(item) in from.params.vKitchenPic" :key="item" class="el-upload-list__item is-success animated">
                        <img :src="item" alt="" class="el-upload-list__item-thumbnail ">
                        <i class="el-icon-close"></i>
                        <span class="el-upload-list__item-actions">
                    <!-- 预览 -->
                    <span class="el-upload-list__item-preview" @click="vKitchenPicCardPreview(item)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                            <!-- 删除 -->
                    <span class="el-upload-list__item-delete" @click="vKitchenPicRemove(item)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                    </li>
                </draggable>
            </ul>
          <el-upload
            multiple
            ref="my-upload"
            :limit="20"
            :headers="headers"
            name="avatarfile"
            :action="GLOBAL"
            :show-file-list="false"
            list-type="picture-card"
            :on-success="vKitchenPicSuccessFour"
            :on-preview="vKitchenPicCardPreview"
            :on-remove="vKitchenPicRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vKitchenPicSuccess"
          >
            <i class="el-icon-upload"></i>
            <!-- <i class="el-icon-plus">添加照片</i> -->
          </el-upload>
          <el-dialog :visible.sync="vKitchenPicLook_img">
            <div class="img_title">浏览图片</div>
            <img width="100%" :src="vKitchenPicLook" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- 阳台 -->
    <div class="picture_box" v-if="balconyNumber">
      <div class="picture_box_top">
        阳台：<span
          >请至少上传
          <div class="text">

               <span style="color: #f6b439;" v-if="hourseInfo.houseInfoSon.iRenderType==1">
                      {{ balconyNumber * 1 > 4 ? "4" : balconyNumber * 1 }}
               </span>
              <span v-else style="color: #f6b439;">1</span>
          </div>
          张阳台照片。光线充足拍摄，效果更好。 </span
        >（{{ this.from.params.vGalleryPic.length }}/20）
      </div>
      <div class="picture_box_bottom">
        <div class="picture_upload">
          <!-- <div class="picture_box_title">可添加照片描述</div> -->
            <ul class="el-upload-list el-upload-list--picture-card">
                <draggable v-model="from.params.vGalleryPic">
                    <li v-for="(item) in from.params.vGalleryPic" :key="item" class="el-upload-list__item is-success animated">
                        <img :src="item" alt="" class="el-upload-list__item-thumbnail ">
                        <i class="el-icon-close"></i>
                        <span class="el-upload-list__item-actions">
                    <!-- 预览 -->
                    <span class="el-upload-list__item-preview" @click="vGalleryPicCardPreview(item)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                            <!-- 删除 -->
                    <span class="el-upload-list__item-delete" @click="vGalleryPicRemove(item)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                    </li>
                </draggable>
            </ul>
          <el-upload
            multiple
            ref="my-upload"
            :limit="20"
            :show-file-list="false"
            :headers="headers"
            name="avatarfile"
            :action="GLOBAL"
            list-type="picture-card"
            :on-success="vGalleryPicSuccessFour"
            :on-preview="vGalleryPicCardPreview"
            :on-remove="vGalleryPicRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vGalleryPicSuccess"
          >
            <i class="el-icon-upload"></i>
            <!-- <i class="el-icon-plus">添加照片</i> -->
          </el-upload>
          <el-dialog :visible.sync="vGalleryPicLook_img">
            <div class="img_title">浏览图片</div>
            <img width="100%" :src="vGalleryPicLook" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
    <!-- 其他 -->
    <div class="picture_box">
      <div class="picture_box_top">
        其他：<span>
          可以是其他室内空间、物件、小区周边环境等。更多的照片往往能吸引更多的房客。 </span
        >（{{ this.from.params.vOtherPic.length }}/20）
      </div>
      <div class="picture_box_bottom">
        <div class="picture_upload">
          <!-- <div class="picture_box_title">可添加照片描述</div> -->
            <ul class="el-upload-list el-upload-list--picture-card">
                <draggable v-model="from.params.vOtherPic">
                    <li v-for="(item) in from.params.vOtherPic" :key="item" class="el-upload-list__item is-success animated">
                        <img :src="item" alt="" class="el-upload-list__item-thumbnail ">
                        <i class="el-icon-close"></i>
                        <span class="el-upload-list__item-actions">
                    <!-- 预览 -->
                    <span class="el-upload-list__item-preview" @click="vOtherPicCardPreview(item)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                            <!-- 删除 -->
                    <span class="el-upload-list__item-delete" @click="vOtherPicRemove(item)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                    </li>
                </draggable>
            </ul>
          <el-upload
            multiple
            ref="my-upload"
            :limit="20"
            :headers="headers"
            name="avatarfile"
            :action="GLOBAL"
            :show-file-list="false"
            list-type="picture-card"
            :on-success="vOtherPicSuccessFour"
            :on-preview="vOtherPicCardPreview"
            :on-remove="vOtherPicRemove"
            :before-upload="beforeAvatarUpload"
            :file-list="vOtherPicSuccess"
          >
            <i class="el-icon-upload"></i>
            <!-- <i class="el-icon-plus">添加照片</i> -->
          </el-upload>
          <el-dialog :visible.sync="vOtherPicLook_img">
            <div class="img_title">浏览图片</div>
            <img width="100%" :src="vOtherPicLook" alt="" />
          </el-dialog>
        </div>
      </div>
    </div>
    <div class="next_Btn" @click="next_Btn">
      <el-button>保存并继续<i class="el-icon-arrow-right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { publishFourAjax, hourseInfo } from "../../api/index";
import  draggable  from 'vuedraggable'
export default {
  props: ["isStatus"],
  components:{
      // eslint-disable-next-line vue/no-unused-components
      draggable
  },
  data() {
    return {
      Status: "",
      vCoverPicSuccess: [],
      vBedroomSuccess: [],
      vSaloonPicSuccess: [],
      vToiletPicSuccess: [],
      vKitchenPicSuccess: [],
      vGalleryPicSuccess: [],
      vOtherPicSuccess: [],
      // GLOBAL: "https://test.youjiaminsu.cn/system/user/profile/housePic", //线上
      // URL: "http://192.168.18.121:8808/system/user/profile/housePic", //本地的
      roomNumber: "", //几室
      hallNumber: "", //厅
      bathroomNumber: "", // 几卫
      kitchenNumber: "", //厨房
      balconyNumber: "", //阳台
      houseId: window.sessionStorage.getItem("hourId").toString() || "",
      active: 5,
      dialogVisible: false,
      vCoverPicLook_img: false,
      vBedroomLook_img: false,
      vSaloonPicLook_img: false,
      vToiletPicLook_img: false,
      vKitchenPicLook_img: false,
      vGalleryPicLook_img: false,
      vOtherPicLook_img: false,
      vCoverPicLook: "",
      vBedroomLook: "",
      vSaloonPicLook: "",
      vToiletPicLook: "",
      vKitchenPicLook: "",
      vGalleryPicLook: "",
      vOtherPicLook: "",
      from: {
        houseId: window.sessionStorage.getItem("hourId").toString() || "",
        params: {
          vCoverPic: "",//封面
          vBedroom: [],//主卧
          vSaloonPic: [],//客厅
          vToiletPic: [],//卫生间
          vKitchenPic: [],//厨房
          vGalleryPic: [],//阳台
          vOtherPic: []//其他
        }
      },
        hourseInfo:{
            houseInfoSon:{

            }
        }
    };
  },
  created() {
      this.$nextTick(()=>{
          document.querySelector(".el-main").scrollTop = 0;
      })
      this.Status = this.isStatus;
    this.hourseInfoAjax();
  },
  computed: {
    headers() {
      return {
        Authorization: "Bearer " + this.$store.state.user // 直接从本地获取token就行
      };
    }
  },
  methods: {
    //     vCoverPicSuccess: [],
    // vBedroomSuccess: [],
    // vSaloonPicSuccess: [],
    // vToiletPicSuccess: [],
    // vKitchenPicSuccess: [],
    // vGalleryPicSuccess: [],
    // vOtherPicSuccess: [],
    async hourseInfoAjax() {
      const { data: res } = await hourseInfo(this.houseId);
      console.log(res);
      this.hourseInfo =  res.data.hourseInfo;
      this.roomNumber = res.data.hourseInfo.roomNumber;
      this.hallNumber = res.data.hourseInfo.hallNumber;
      this.bathroomNumber = res.data.hourseInfo.bathroomNumber;
      this.kitchenNumber = res.data.hourseInfo.kitchenNumber;
      this.balconyNumber = res.data.hourseInfo.balconyNumber;
      //  params: {
      //     vCoverPic: "",
      //     vBedroom: [],
      //     vSaloonPic: [],
      //     vToiletPic: [],
      //     vKitchenPic: [],
      //     vGalleryPic: [],
      //     vOtherPic: []
      //   }
      this.from.params.vCoverPic =
        res.data.hourseInfo.houseInfoSon.vCoverPics || "";
      this.from.params.vBedroom =
        res.data.hourseInfo.houseInfoSon.vBedrooms || [];
      this.from.params.vSaloonPic =
        res.data.hourseInfo.houseInfoSon.vSaloonPics || [];
      this.from.params.vToiletPic =
        res.data.hourseInfo.houseInfoSon.vToiletPics || [];
      this.from.params.vKitchenPic =
        res.data.hourseInfo.houseInfoSon.vKitchenPics || [];
      this.from.params.vGalleryPic =
        res.data.hourseInfo.houseInfoSon.vGalleryPics || [];
      this.from.params.vOtherPic =
        res.data.hourseInfo.houseInfoSon.vOtherPics || [];

      if (res.data.hourseInfo.houseInfoSon.vCoverPics !== null) {
        this.vCoverPicSuccess = res.data.hourseInfo.houseInfoSon.vCoverPics.map(
          item => {
            return {
              url: item
            };
          }
        );
      }
      if (res.data.hourseInfo.houseInfoSon.vBedrooms !== null) {
        this.vBedroomSuccess = res.data.hourseInfo.houseInfoSon.vBedrooms.map(
          item => {
            return {
              url: item
            };
          }
        );
      }

      if (res.data.hourseInfo.houseInfoSon.vSaloonPics !== null) {
        this.vSaloonPicSuccess = res.data.hourseInfo.houseInfoSon.vSaloonPics.map(
          item => {
            return {
              url: item
            };
          }
        );
      }

      if (res.data.hourseInfo.houseInfoSon.vToiletPics !== null) {
        this.vToiletPicSuccess = res.data.hourseInfo.houseInfoSon.vToiletPics.map(
          item => {
            return {
              url: item
            };
          }
        );
      }

      if (res.data.hourseInfo.houseInfoSon.vKitchenPics !== null) {
        this.vKitchenPicSuccess = res.data.hourseInfo.houseInfoSon.vKitchenPics.map(
          item => {
            return {
              url: item
            };
          }
        );
      }

      if (res.data.hourseInfo.houseInfoSon.vGalleryPics !== null) {
        this.vGalleryPicSuccess = res.data.hourseInfo.houseInfoSon.vGalleryPics.map(
          item => {
            return {
              url: item
            };
          }
        );
      }

      if (res.data.hourseInfo.houseInfoSon.vOtherPics !== null) {
        this.vOtherPicSuccess = res.data.hourseInfo.houseInfoSon.vOtherPics.map(
          item => {
            return {
              url: item
            };
          }
        );
      }
    },
    // ---------------------封面图-----------------------
    vCoverPicSuccessFour(response) {
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });

      if (this.from.params.vCoverPic.indexOf(response.msg) == -1) {
        this.from.params.vCoverPic = response.msg;
      }
    },
    vCoverPicRemove(file, fileList) {
      console.log(file);
      this.from.params.vCoverPic = "";
    },
    vCoverPicCardPreview(file) {
      console.log(file);
      this.vCoverPicLook = file.url;
      this.vCoverPicLook_img = true;
    },
      onStart(){
          console.log('开始拖拽',this.from.params.vBedroom)
      },
      onEnd(){
          console.log('结束拖拽',this.from.params.vBedroom)
      },
    // ---------------------卧室-----------------------
    vBedroomSuccessFour(response) {
      // console.log(response, "1");
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });

      if (this.from.params.vBedroom.indexOf(response.msg) == -1) {
        this.from.params.vBedroom.push(response.msg);
      }
      console.log(this.from.params.vBedroom);
    },
    vBedroomCardPreview(file, fileList) {
      this.vBedroomLook = file;
      this.vBedroomLook_img = true;
    },
    vBedroomRemove(file) {
        console.log(this.from.params.vBedroom,file)
      if (file !== undefined) {
        var index = this.from.params.vBedroom.indexOf(file);
      } else {
        var index = this.from.params.vBedroom.indexOf(file);
      }

      if (index !== -1) {
        this.from.params.vBedroom.splice(index, 1);
      }
    },
    // ---------------------客厅-----------------------
    vSaloonPicSuccessFour(response) {
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });
      if (this.from.params.vSaloonPic.indexOf(response.msg) == -1) {
        this.from.params.vSaloonPic.push(response.msg);
      }
    },
    vSaloonPicCardPreview(file, fileList) {
      console.log(file);
      this.vSaloonPicLook = file;
      this.vSaloonPicLook_img = true;
    },
    vSaloonPicRemove(file) {
      if (file !== undefined) {
        var index = this.from.params.vSaloonPic.indexOf(file);
      } else {
        var index = this.from.params.vSaloonPic.indexOf(file);
      }
      if (index !== -1) {
        this.from.params.vSaloonPic.splice(index, 1);
        console.log(this.from.params.vSaloonPic);
      }
    },
    // ---------------------卫生间-----------------------
    vToiletPicSuccessFour(response) {
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });
      if (this.from.params.vToiletPic.indexOf(response.msg) == -1) {
        this.from.params.vToiletPic.push(response.msg);
      }
    },
    vToiletPicCardPreview(file, fileList) {
      this.vToiletPicLook = file;
      this.vToiletPicLook_img = true;
    },
    vToiletPicRemove(file) {
      if (file.response !== undefined) {
        var index = this.from.params.vToiletPic.indexOf(file);
      } else {
        var index = this.from.params.vToiletPic.indexOf(file);
      }

      if (index !== -1) {
        this.from.params.vToiletPic.splice(index, 1);
      }
    },
    // ---------------------厨房-----------------------
    vKitchenPicSuccessFour(response) {
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });
      if (this.from.params.vKitchenPic.indexOf(response.msg) == -1) {
        this.from.params.vKitchenPic.push(response.msg);
      }
    },
    vKitchenPicCardPreview(file, fileList) {
      this.vKitchenPicLook = file;
      this.vKitchenPicLook_img = true;
    },
    vKitchenPicRemove(file) {
      if (file.response !== undefined) {
        var index = this.from.params.vKitchenPic.indexOf(file);
      } else {
        var index = this.from.params.vKitchenPic.indexOf(file);
      }
      if (index !== -1) {
        this.from.params.vKitchenPic.splice(index, 1);
      }
    },
    // ---------------------阳台-----------------------
    vGalleryPicSuccessFour(response) {
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });
      if (this.from.params.vGalleryPic.indexOf(response.msg) == -1) {
        this.from.params.vGalleryPic.push(response.msg);
      }
    },
    vGalleryPicCardPreview(file, fileList) {
      this.vGalleryPicLook = file;
      this.vGalleryPicLook_img = true;
    },
    vGalleryPicRemove(file) {
      if (file !== undefined) {
        var index = this.from.params.vGalleryPic.indexOf(file);
      } else {
        var index = this.from.params.vGalleryPic.indexOf(file);
      }
      if (index !== -1) {
        this.from.params.vGalleryPic.splice(index, 1);
      }
    },
    // ---------------------其他-----------------------
    vOtherPicSuccessFour(response) {
      if (response.code !== 200)
        return this.$message({
          message:
            "图片格式错误，请删除图片，重新上传正确的图片格式（JPG,PNG）",
          type: "error"
        });
      if (this.from.params.vOtherPic.indexOf(response.msg) == -1) {
        this.from.params.vOtherPic.push(response.msg);
      }
    },
    vOtherPicCardPreview(file, fileList) {
      console.log(file);
      this.vOtherPicLook = file;
      this.vOtherPicLook_img = true;
    },
    vOtherPicRemove(file) {
      console.log(file);

      if (file !== undefined) {
        var index = this.from.params.vOtherPic.indexOf(file);
      } else {
        var index = this.from.params.vOtherPic.indexOf(file);
      }

      if (index !== -1) {
        this.from.params.vOtherPic.splice(index, 1);
      }
    },
    beforeAvatarUpload(file) {
      console.log(file);
      let isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isLt2M;
    },
    async next_Btn() {
        console.log(this.from)
        let num1 = this.from.params.vBedroom.length;
        let num2 = this.from.params.vSaloonPic.length //客厅
        let num3 = this.from.params.vToiletPic.length //卫生间
        let num4 = this.from.params.vKitchenPic.length
        let num5 = this.from.params.vGalleryPic.length
       let arr = [
           {
               number:this.roomNumber,
               picNum:num1
           },
           {
               number:this.hallNumber,
               picNum:num2
           },
           {
               number:this.bathroomNumber,
               picNum:num3
           },
           {
               number:this.kitchenNumber,
               picNum:num4
           },
           {
               number:this.balconyNumber,
               picNum:num5
           }
       ]
       /* roomNumber: "", //几室
            hallNumber: "", //厅
            bathroomNumber: "", // 几卫
            kitchenNumber: "", //厨房
            balconyNumber: "", //阳台*/
       let num = [num1,num2,num3,num4,num5].reduce((x,y)=>x+y)
        //整租才限制图片
        /*if(this.hourseInfo.houseInfoSon.iRenderType==1&& num<5){
            return  this.$message.warning("请至少上传5张图片");
        }*/
        if(arr.find(item=>item.number>0&&item.picNum==0)){
            return  this.$message.warning("请至少上传1张图片");

        }
        this.from['iRenderType'] = this.hourseInfo.houseInfoSon.iRenderType
      const { data: res } = await publishFourAjax(this.from);
      if (res.code !== 200) {
        return this.$message({
          type: "error",
          message: res.data
        });
      }
      this.vCoverPicLook = "";
      this.vBedroomLook = "";
      this.vSaloonPicLook = "";
      this.vToiletPicLook = "";
      this.vKitchenPicLook = "";
      this.vGalleryPicLook = "";
      this.vOtherPicLook = "";
      this.from = {
        houseId: window.sessionStorage.getItem("hourId").toString() || "",
        params: {
          vCoverPic: "",
          vBedroom: [],
          vSaloonPic: [],
          vToiletPic: [],
          vKitchenPic: [],
          vGalleryPic: [],
          vOtherPic: []
        }
      };
      this.$refs["my-upload"].clearFiles();
      this.$emit("active", this.active);
      return this.$message({
        type: "success",
        message: res.msg
      });
    }
  }
};
</script>

<style lang="less" scoped>
.information_title {
  height: 66px;
  line-height: 66px;
  margin-top: 30px;
  color: #f6b439;
  font-size: 20px;
  border-bottom: 1px solid #e1e1e1;
}
.next_Btn {
  margin: 90px 0 94px 36px;
  .el-button {
    font-size: 24px;
    color: #fff;
    width: 204px;
    height: 64px;
    background-color: #f6b439;
  }
}
.picture_title {
  margin-top: 30px;
  margin-left: 36px;
  .picture_title_top {
    font-size: 18px;
    line-height: 24px;
    color: #000000;
  }
  .picture_title_bottom {
    margin-top: 10px;
    font-size: 18px;
    line-height: 24px;
    color: #f6b439;
  }
}
.picture_box {
  margin: 25px 36px;
  min-height: 214px;
  .picture_box_top {
    font-size: 18px;
    span {
      color: #666666;
    }
    .text {
      display: inline;
      color: #f6b439;
    }
  }
}
.picture_box_bottom {
  margin-top: 20px;
  min-height: 120px;

  .picture_upload {
      display: flex;
      flex-wrap: wrap;
    position: relative;
    margin-right: 20px;
    min-height: 120px;
    // width: 120px;
  }
}
/deep/.el-upload--picture-card {
  width: 120px;
  height: 120px;
  line-height: 120px;
}

/deep/.el-upload-list--picture-card .el-upload-list__item {
  height: 120px;
  width: 120px;
  margin-right: 20px;
}
.img_title {
  position: absolute;
  top: 24px;
  left: 30px;
  font-weight: bold;
  font-size: 20px;
  color: #000;
}
// .picture_box_title {
//   position: absolute;
//   width: 120px;
//   height: 20px;
//   color: #ffffff;
//   font-size: 12px;
//   text-align: center;
//   background: rgba(0, 0, 0, 0.3);
// }
</style>
